import UserModal from './UserModalContainer';

export default UserModal;
